var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"c-app-icon",class:{ 'c-app-icon--filled': _vm.filled },style:({ fontSize: `${_vm.size}px` }),attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.name))])
}
var staticRenderFns = []

export { render, staticRenderFns }